import { Button } from '@material-ui/core';
import { useState } from 'react';
import { ActionHeader } from '.';
import en from '../../../lang/en-us';
import { UploadFile } from '../../../lib/UploadFile.tsx';
const { dashboard } = en;

export default function UploadDocumentScreen({
    backLink = '',
    heading = '',
    subheading = '',
    info1 = '',
    info2 = '',
    linkText = '',
    nextLink = '',
    id = 'document',
    onImageSelected = (value: any, format: any) => {},
    handleSubmit = () => {},
    isDisabled = true,
    hrefLink = '#',
}) {
    return (
        <>
            <ActionHeader header={heading} />
            <div className="curved-bg-content">
                <img className="upload-character" src="/images/upload-character.png" alt="" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">{subheading}</h3>
                        <p>
                            {info1}
                            <span
                                className="upload-document-link"
                                onClick={() => {
                                    window.open(`${hrefLink}`, '_system');
                                }}
                            >
                                {linkText}
                            </span>
                            {info2}
                        </p>
                        <UploadFile onImageSelected={onImageSelected} id={id} />
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <Button
                            // href={`/portal/${nextLink}`}
                            onClick={handleSubmit}
                            className="customBtn"
                            disabled={!isDisabled}
                        >
                            {dashboard.changeEmail.UploadDocument.buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}
